import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import { PdpSharedShippingCustomsDisclaimer_item$key } from './__generated__/PdpSharedShippingCustomsDisclaimer_item.graphql';

// styles
import styles from './PdpSharedShippingCustomsDisclaimer.scss';

type Props = {
    item: PdpSharedShippingCustomsDisclaimer_item$key;
    currency: string;
};

const PdpSharedShippingCustomsDisclaimer: FC<Props> = ({ item: itemRef, currency }) => {
    const item = useFragment(
        graphql`
            fragment PdpSharedShippingCustomsDisclaimer_item on Item {
                dutiesInfo(buyerId: $userId) {
                    duties
                }
            }
        `,
        itemRef
    );

    const customsCode = item?.dutiesInfo?.duties;

    const formattedDuties = <FormattedNumber value={0} style="currency" currency={currency} />;

    let legalMessage;
    if (customsCode === 'NOT_DUTY_EXEMPT') {
        legalMessage = (
            <FormattedMessage
                id="pdp.mainPageShippingDetailsDisclaimer.notExempt"
                defaultMessage="Customs duties and taxes may apply to international purchases. <learnMoreLink>Learn more</learnMoreLink> in our support center."
                values={{
                    learnMoreLink: words => (
                        <Link
                            href="https://support.1stdibs.com/s/article/Customs-Duties-and-Taxes-for-International-Shipments?_ga=2.226635358.256726246.1595260514-1431767277.1560791984"
                            title="learn-more-link"
                            target="_blank"
                        >
                            {words}
                        </Link>
                    ),
                }}
            />
        );
    } else if (customsCode === 'DUTY_EXEMPT') {
        legalMessage = (
            <FormattedMessage
                id="pdp.mainPageShippingDetailsDisclaimer.noDuty"
                defaultMessage="Estimated Customs and Duties: {formattedDuties}"
                values={{
                    formattedDuties,
                }}
            />
        );
    }

    return (
        <div className={styles.detailsDisclaimer}>
            <p className={styles.detailsDisclaimer}>{legalMessage}</p>
        </div>
    );
};

export default PdpSharedShippingCustomsDisclaimer;
